import styled, { css, keyframes } from 'styled-components';
import Modal from '~/componentes/Modal';
import { Colors } from '~/config/Colors';

export const Overlay = styled.div`
  ${() => css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2px);

    opacity: 0;

    animation: ${fadeInAnimation} 750ms forwards;

    z-index: 10;
  `}

  ${({ isShowMenu }) =>
    isShowMenu === false &&
    css`
      animation: ${fadeOutAnimation} 750ms forwards;
    `}
`;

const fadeInAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`;

const fadeOutAnimation = keyframes`
 0% { opacity: 1; }
 100% { opacity: 0; }
`;

const slideDownAnimation = keyframes`
 0% {
   opacity: 0;
   transform: translateY(-10px);
 }
 100% {
   opacity: 1;
   transform: translateY(0);
 }
`;

export const ButtonMenuPerfil = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 1rem;
  margin-right: 0em !important;
  border: 0;
  background: ${Colors.Color2};

  .circul-perfil {
    width: 1.8rem;
    height: 1.8rem;
    background: ${Colors.Color4};
    border-radius: 3rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    p {
      color: ${Colors.Color2};
      font-size: 0.8rem;
      font-weight: 900;
    }
  }

  .info-perfil {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 0.8rem;

    .text-nome {
      font-size: 0.76rem;
      font-weight: 600;
      line-height: 1rem;
      color: ${Colors.Color5};
    }

    .text-email {
      font-size: 0.6rem;
      line-height: 1.5rem;
      color: ${Colors.Color6};
    }
  }
`;

export const Content = styled(Modal)`
  position: absolute;
  top: 90%;
  right: 1.5rem;

  width: 15.875rem;
  max-width: 100%;

  z-index: 11;
  padding: 0.8rem;
  background: ${Colors.Color1};
  border-radius: 1rem;
  box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;

  animation: ${slideDownAnimation} 300ms ease-out forwards;

  .margin-top {
    margin-top: 1rem;
    display: block;
  }

  .sec-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: ${Colors.Color2};
    width: fit-content;
    padding: 0.3em 1.2em 0.3em 0.7rem;
    border-radius: 0.5rem;
    margin-bottom: 0.5rem;

    .title {
      color: ${Colors.Color7};
      font-size: 0.7125rem;
      font-weight: 700;
      margin-left: 0.6rem;
      line-height: 1rem;
    }

    img {
      width: 1rem;
    }
  }

  .header-acesso {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 0.5rem;

    .lateral-e {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: ${Colors.bgColor4};
      border-radius: 2rem;
      padding: 0 1rem;
      height: 1.6rem;

      .title {
        color: ${Colors.ftColor3};
        font-size: 0.75rem;
        font-weight: 600;
        margin: 0;
      }
    }

    .lateral-d {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: ${Colors.bgColor4};
      border-radius: 2rem;
      padding: 0 0.5rem;

      img {
        width: 0.8rem;
      }
    }
  }

  .perfil {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    button {
      margin: 0;
      margin-right: 1rem;
      margin-left: 0.5rem;
      width: 2.2rem;
      height: 2.2rem;

      p {
        font-size: 1.2rem;
        line-height: 0.9rem;
      }
    }

    .content {
      margin-left: 1rem;

      h5 {
        color: ${Colors.ftColor3};
        font-size: 0.7rem;
        font-weight: 600;
      }

      h6 {
        color: ${Colors.ftColor1};
        font-weight: 400;
      }
    }
  }
`;

export const OpcaoButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0.5em 1rem;
  border: 0;
  border-radius: 0.5rem;
  background: ${Colors.Color1};

  .img-acesso {
    width: 1.5rem;
  }

  .texto-acesso {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 0.6rem;

    h6 {
      color: ${Colors.Color7};
      font-size: 0.7rem;
      line-height: 1rem;
      font-weight: 700;
    }
  }
`;

export const AcessoButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0.5em 1rem;
  border: 0;
  border-radius: 0.5rem;
  ${props => (props.ativo ? `background: ${Colors.Color8};` : `background: ${Colors.Color1};`)};

  .img-acesso {
    width: 1.5rem;
  }

  .texto-acesso {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 0.6rem;

    h5 {
      ${props => (props.ativo ? `color: ${Colors.Color7};` : `color: ${Colors.Color7};`)};
      font-size: 0.65rem;
      line-height: 1.5rem;
      font-weight: 500;
    }

    h6 {
      ${props => (props.ativo ? `color: ${Colors.Color4};` : `color: ${Colors.Color7};`)};
      font-size: 0.7rem;
      line-height: 1rem;
      font-weight: 700;
    }
  }

  ::before {
    content: '';
    position: absolute;
    width: 0.2rem;
    height: 60%;
    left: 0rem;
    top: 20%;
    ${props => (props.ativo ? `background: ${Colors.Color4};` : `background: ${Colors.Color1};`)};
    border-radius: 0.2rem;
  }
`;
